const hasLocalStorage = () => typeof window !== 'undefined' && window.localStorage;

export default hasLocalStorage;
